import { c } from 'ttag';

import { Button } from '@proton/atoms/Button/Button';
import { IcExclamationCircle } from '@proton/icons/icons/IcExclamationCircle';

import Alert from '../../../components/alert/Alert';
import ModalTwoContent from '../../../components/modalTwo/ModalContent';
import ModalTwoFooter from '../../../components/modalTwo/ModalFooter';
import ModalTwoHeader from '../../../components/modalTwo/ModalHeader';

interface Props {
    model: {
        errorOnMerge?: boolean;
        errorOnLoad?: boolean;
    };
    onClose?: () => void;
}

const ContactMergeErrorContent = ({ model, onClose }: Props) => {
    const error = model.errorOnLoad
        ? c('Warning').t`Some of the contacts to be merged display errors. Please review them individually`
        : c('Warning').t`Contacts could not be merged`;

    return (
        <>
            <ModalTwoHeader title={c('Title').t`Contact Details`} />
            <ModalTwoContent>
                <Alert type="warning">
                    <IcExclamationCircle className="mr-4" />
                    <span className="mr-4">{error}</span>
                </Alert>
            </ModalTwoContent>
            <ModalTwoFooter>
                <Button onClick={onClose}>{c('Action').t`Cancel`}</Button>
            </ModalTwoFooter>
        </>
    );
};

export default ContactMergeErrorContent;
